const FILTER_STATE_GROUPS = [
    {
        pageTypes: ['team'],
        storageKeys: ['filterState_team']
    },
    {
        pageTypes: ['news'],
        storageKeys: ['filterState_news']
    },
    {
        // "Portfolio" context can be represented as investments section or single investment page.
        pageTypes: ['investments', 'investment', 'portfolio'],
        storageKeys: ['filterState_investments', 'filterState_investment', 'activeCases']
    }
];

function getPagePostTypes(root = document) {
    const nodes = Array.from(root.querySelectorAll('[data-postype]'));
    return new Set(
        nodes
            .map(node => String(node?.dataset?.postype || '').trim().toLowerCase())
            .filter(Boolean)
    );
}

export function clearFilterStatesByPageContext(root = document) {
    try {
        const pageTypes = getPagePostTypes(root);

        FILTER_STATE_GROUPS.forEach(({ pageTypes: allowedTypes, storageKeys }) => {
            const isRelatedPage = allowedTypes.some(type => pageTypes.has(type));
            if (isRelatedPage) return;

            storageKeys.forEach(key => localStorage.removeItem(key));
        });
    } catch (e) {
        // Access to storage may be blocked in strict privacy mode.
    }
}

export default function clearLocalStorage() {
    localStorage.removeItem('resetAll');
    localStorage.removeItem('postType');
    localStorage.removeItem('searchInput');
    localStorage.removeItem('activeFilters');
    localStorage.removeItem('activeCases');
}
